import React, { RefAttributes, useEffect, StrictMode, useRef } from "react";
import Leaflet, { LatLngExpression } from "leaflet";
import * as ReactLeaflet from "react-leaflet";
import "leaflet/dist/leaflet.css";
const {
  MapContainer
} = ReactLeaflet;
const Map = ({
  children,
  className,
  ...rest
}: {
  center: LatLngExpression | undefined;
  zoom: number;
  maxZoom: number;
  children: (reactLeaflet: any, leaflet: any) => any;
} & Omit<ReactLeaflet.MapContainerProps & RefAttributes<Leaflet.Map>, "children">) => {
  useEffect(() => {
    // @ts-expect-error
    delete Leaflet.Icon.Default.prototype._getIconUrl;
    Leaflet.Icon.Default.mergeOptions({
      iconRetinaUrl: "/leaflet/images/marker-icon-2x.png",
      iconUrl: "/leaflet/images/marker-icon.png",
      shadowUrl: "/leaflet/images/marker-shadow.png"
    });
  }, []);
  return <MapContainer {...rest} data-sentry-element="MapContainer" data-sentry-component="Map" data-sentry-source-file="DynamicMap.tsx">{children(ReactLeaflet, Leaflet)}</MapContainer>;
};
export default Map;